import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 update_tenant_logo: { message: "idle" },
};

export const update_tenant_logo_Slice = createSlice({
 name: "update_tenant_logo",
 initialState,
 reducers: {
  success_update_tenant_logo: (state, action) => {
   state.update_tenant_logo = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_update_tenant_logo: (state, action) => {
   state.update_tenant_logo = { status: app_consts.FAIL, message: action.payload };
  },
  reset_update_tenant_logo: (state) => {
   state.update_tenant_logo = { status: app_consts.IDLE };
  },
  loading_update_tenant_logo: (state) => {
   state.update_tenant_logo = { status: app_consts.LOADING };
  },
 }
});

export const { success_update_tenant_logo, fail_update_tenant_logo, reset_update_tenant_logo, loading_update_tenant_logo } = update_tenant_logo_Slice.actions;

export default update_tenant_logo_Slice.reducer;